import React, { useEffect, useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import Table from 'react-bootstrap/Table';
import { Container } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Pagination from 'react-bootstrap/Pagination';
import { useDispatch, useSelector } from "react-redux";
import { app_url } from "../services/http";
import { incrementQ ,decrementQ,removeFromCart } from "../app/providers/panierSlice";
import PublicationsService from "../services/PublicationsService";
import PeriodiquesService from "../services/PeriodiquesService";
import Badge from 'react-bootstrap/Badge';
import Swal from "sweetalert2";
import Modal from 'react-bootstrap/Modal';

//importer material ui design
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";


export default function Monpanier() {
    
    const [quantity, setQuantity] = useState(1);
    // liste des articles dans le panier
    const {contentPanier} = useSelector(state => state.panier)
    // utilisation de dispatch pour l'exploitation des fonctions depuis le reducer
    const dispatch = useDispatch()

    const [publications, setPublications] = useState([]);

    const [publication, setPublication] = useState(null);

    const [data, setData] = useState([]);
  
    const [periodiques, setPeriodiques] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 4; // Nombre d'éléments par page

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);

    const auth = useSelector(state => state.auth);


    const openModal = () => {
      setModalOpen(true);
    };

    const closeModal = () => {
      setModalOpen(false);
    };
    
    let navigate = useNavigate();


  // Fonction de gestion du changement de page
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calcul du nombre total de pages
  const pageCount = Math.ceil(contentPanier.length / itemsPerPage);

  // Obtenir les éléments à afficher dans la page actuelle
const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;
const paginatedData = contentPanier.slice(startIndex, endIndex);

useEffect(() => {
  const fetchPublications = async () => {
      try {
        const response = await PublicationsService.index();
        setPublications(response.data.publications); // Utilisez response.data.publications au lieu de response.data
        // Récupérer les libellés des périodiques à partir des IDs
        const ids = response.data.publications.map(publication => publication.periodique_id);
        const periodiquesResponse = await PeriodiquesService.index(ids);
        setPeriodiques(periodiquesResponse.data.liste_periodiques);
        //console.log(periodiquesResponse.data.liste_periodiques)

      } catch (error) {
        console.log(error);
      }
    };
    
  fetchPublications();
}, []);

useEffect(() => {
  // Vérifiez si l'utilisateur est connecté
  const checkLoggedInStatus = () => {
    const token = localStorage.getItem("token");
    if (token && token !== null) {
      setIsLoggedIn(true);
    }
  };
  
  // Appelez la fonction pour vérifier le statut de connexion de l'utilisateur
  checkLoggedInStatus();
}, []); // Les crochets vides [] indiquent que le useEffect s'exécute une seule fois après le rendu initial

const handleValidation = () => {
  if (auth.isAuthenticate) {
    // L'utilisateur est connecté, redirigez-le vers la page de commande
    //alert("ok")
    navigate(myroutes.commandes);
  } else {
    // L'utilisateur n'est pas connecté, ouvrez le modal demandant de se connecter
    openModal();
  }
};


 
    return (
    <LayoutFrontend>   
          {/** Navbar Start */}
    <div className="container-fluid position-relative p-0">
    
                <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Mon panier</h1>
                    <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.homepage}>
                    Accueil
                    </Link>
                    <i className="far fa-circle text-white px-2"></i>
                    <Link className="h5 text-white" to={myroutes.monpanier}>
                   panier        
                 </Link>
                </div>
            </div>
        </div>
       
    </div>
    {/** Navbar End */}

    <Container>
<section className="h-100" style={{ backgroundColor: "#eee" }}>
  <div className="container h-100 py-5">
    <div className="row d-flex justify-content-center align-items-center h-100">
      <div className="col-10">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="fw-normal mb-0"><Link to={myroutes.homepage} className="text-body"><i
                      className="fas fa-long-arrow-alt-left text-primary me-2"></i><span style={{color:"#116BB9"}}>Continuer mes achats</span></Link></h5>
           <hr/>
          <div>
            <p className="mb-0"><span className=""><i
              className="fas fa-shopping-cart mt-1 me-2"></i>Mon panier</span></p>
          </div>
        </div>

        {paginatedData.map((item) => (
          <div className="card rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-md-2 col-lg-2 col-xl-2">
                  <img
                  src={app_url + "/storage/laune/" + item.laune}
                  alt="Image"
                  className="img-fluid rounded-3"
                />
                 
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <p className="lead fw-normal mb-2">{item.name}</p>
                  <p className="mt-3 text-primary">
                    <span className="text-muted">Prix: </span>
                    {item.price?.toLocaleString()} F CFA
                  </p>
                </div>
                <div className="col-md-3 col-lg-3 col-xl-2 d-flex">
                <Button onClick={() => dispatch(decrementQ(item))} variant="outline-dark" disabled>
                  -
                </Button>

                <span style={{ margin: "20px" }}>{item.quantity}</span>

              <Button onClick={() => dispatch(incrementQ(item))} variant="outline-dark" disabled>
                +
              </Button>{''}
                </div>
                <div className="col-md-3 col-lg-2 col-xl-2 offset-lg-1">
                <h5 className="mb-0">{(item.price * item.quantity).toLocaleString()} F CFA</h5>
                </div>
                <div className="col-md-1 col-lg-1 col-xl-1 text-end">
          
                  <Link onClick={() => dispatch(removeFromCart(item))} className="text-danger">
                    <i className="fas fa-trash fa-lg"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="card mb-3">
          <div className="card-body">
            <div className="col-md-12">
              <div className="row">
              <div className="col-md-6">
              <button type="button" className="btn btn-primary btn-block btn-lg">
              <span style={{fontSize: "18px"}}>
                Total Panier : {contentPanier.reduce((acc, item) => acc += item.price * item.quantity, 0).toLocaleString()} F CFA
              </span>
            </button>
              </div>
              <div className="col-md-6">
              <button type="button"  onClick={handleValidation} className="btn btn-warning btn-block btn-lg" style={{fontSize:"18px"}}>Valider mon panier</button>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="m-3 p-2">
 {/** <Pagination >
        {Array.from({ length: pageCount }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={currentPage === index + 1}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination> */}
        </div>
</section>

          <Modal show={modalOpen} onHide={closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>Connexion requise</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Vous devez être connecté pour accéder à la page de commande.</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Fermer
              </Button>
              <Button variant="primary" onClick={() => navigate(myroutes.login)}>
                Se connecter
              </Button>
            </Modal.Footer>
          </Modal>
    {/** <div className="mt-5">
    <p style={{fontWeight:"bold", color:"black", fontSize:"20px", fontStyle:"italic", textAlign:"center"}}> ( Nous acceptons <img src="../startup/img/modepaiement.png" alt="modepaiement" /> pour tous vos paiements | 100% sécurisée )</p>
    </div>

  <Table striped bordered hover size="sm" >
      <thead style={{backgroundColor:"#116BB9", color:"white",fontSize:"18px"}}>
        <tr>
          <th style={{padding:"10px", width:"600px"}}>Parution</th>
          <th style={{padding:"10px", width:"200px"}}>Prix</th>
          <th style={{padding:"10px", width:"200px"}}>Quantité</th>
          <th style={{padding:"10px", width:"200px"}}>Total</th>
        </tr>
      </thead>
      <tbody>
        {paginatedData.map((item)  => (
            <tr key={item.id}>

            <td style={{ padding: "20px", display: "flex", alignItems: "center" }}>
              <img
                src={app_url + "/storage/laune/" + item.laune}
                alt="Image"
                style={{ width: '200px', height: 'auto' }}
              />
              <p style={{ marginLeft: "10px", fontSize: "20px",lineHeight:"1.5rem" }}>{item.name}</p>
            </td>


            <td style={{ verticalAlign: "middle" }}>{item.price}</td>

            <td style={{ verticalAlign: "middle" }}>
            <Button onClick={() => dispatch(decrementQ(item))} variant="outline-dark">
               -
            </Button>
            <span style={{ margin: "20px" }}>{item.quantity}</span>
            <Button onClick={() => dispatch(incrementQ(item))} variant="outline-dark">
               +
            </Button>{''}
            <div>
              <p></p>
            </div>
            <Button onClick={() => dispatch(removeFromCart(item))} variant="dark">
            <i className="fa fa-trash" aria-hidden="true"></i> supprimer
            </Button>
        </td>

            <td style={{ verticalAlign: "middle", fontWeight:"bold" }}>{item.quantity*item.price}</td>
            </tr>
        ))}
        </tbody>

      <tfoot style={{backgroundColor: "rgb(199, 222, 255)"}}>
        <th colSpan={4} style={{padding:"10px",textAlign:"center", fontSize:"22px"}}>
        <span > Total Panier : {contentPanier.reduce((acc,item) => acc += item.price * item.quantity,0)} FCFA</span>
        </th>
      </tfoot>
    </Table>
    <Pagination >
        {Array.from({ length: pageCount }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={currentPage === index + 1}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    <Row>
            <Col xs={8} md={6}>
            </Col>
            <Col xs={8} md={6}>
            <Button className="me-3 mt-4 mb-5" href={myroutes.homepage} variant="primary" style={{ padding:"15px", borderRadius:"4px" }}>Continuer mes achats</Button>{' '}
            <Button className="me-3 mt-4 mb-5" onClick={handleValidation} variant="warning" style={{ padding:"15px", borderRadius:"4px",  }}>Valider mon panier</Button>{' '}
            </Col>
            
           
    </Row>*/}
    </Container>
    </LayoutFrontend>
   
 
   )
}